import {Frontend} from "./frontend";

(function () {
    XonBoard.AssetsDistributionMaps = {
        list: {
            selectors: {
                assets_distribution_maps_table: $('#assets-distribution-maps-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.assets_distribution_maps_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.assets_distribution_maps_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsFiltered);
                            return json.data;
                        },
                        data: Frontend.DataTableSearch.globalFilter,
                    },
                    columns: [
                        {
                            data: 'name',
                            name: 'assets_distribution_maps.name',
                            render: (name, type, map) => `<span class="name-with-logo">${map.image || '<span class="name-with-logo__placeholder"><i class="fa fa-map" aria-hidden="true"></i></span>'}<span>${name}</span></span>`
                        },
                        {data: 'description', name: 'assets_distribution_maps.description'},
                        {data: 'site_name', name: 'sites.name', searchable: false,},
                        {data: 'status', name: 'assets_distribution_maps.status', searchable: false,},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
        },

        create: {
            init: function () {
                XonBoard.Utils.Select2.init();
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
